/* eslint-disable security/detect-object-injection */
import HttpRequest from '@/config/axios.config'
import { v4 as uuidv4 } from 'uuid'
import {
  find,
  forEach,
  get,
  includes,
  isEmpty,
  isObject,
  orderBy,
  set,
  split,
} from 'lodash'
import { IInputProperty } from '@/screens/Order/interface/common.interface'
import { convertImageToBase64, isEmptyValue } from '@/utils/common'
import { transformBase64 } from '@/utils/image'
import { quantity_breakdown_types_obj } from '../../constant/quanity_breakdown'
import { USER_ROLE } from '@/constant/user'
import { INSPECTION_PERMISSION } from '@/screens/QSF/Inspection/Inspection.constant'
import {
  COLOR_SIZE_SEPARATOR_KEY,
  COLOR_SIZE_SEPARATOR_KEY_LENGTH,
} from '@/constant/pbf'
import { dateFormat } from '@/utils/date'
import { IsAdminRole } from '@/utils/users'
import { DATE_FORMAT } from '@/constant/date'
import { FIELD_INPUT_TYPE } from '../Order.constant'

const { ADMIN } = USER_ROLE

export const getBase64 = (file: any): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = (error) => reject(error)
  })

export async function orderProperty(formValue, picture) {
  try {
    const properties: Array<IInputProperty> = []
    let mediaId: any = null

    if (!isEmptyValue(formValue.picture)) {
      if (formValue.picture[0].url_path) {
        const base64Image = await convertImageToBase64(
          formValue.picture[0].url_path
        )
        const { size } = formValue.picture[0]
        const payload = {
          media_id: uuidv4(),
          reference_id: uuidv4(),
          table: 'orders',
          name: uuidv4(),
          data_raw: transformBase64(base64Image),
          type: 'image/jpg',
          size: `${size}`,
        }
        const respond = await HttpRequest.post(`/inspections/image`, payload)
        return respond.data.data.id
      }

      if (!isEmptyValue(formValue.picture[0].originFileObj)) {
        const { size } = formValue.picture[0].originFileObj
        const data_raw = await getBase64(formValue.picture[0].originFileObj)
        const payload = {
          media_id: uuidv4(),
          reference_id: uuidv4(),
          table: 'orders',
          name: uuidv4(),
          data_raw: data_raw,
          type: 'image/jpg',
          size: `${size}`,
        }
        const respond = await HttpRequest.post(`/inspections/image`, payload)
        return respond.data.data.id
      }
      ///Check if field picture from order exist///
      else if (
        !isEmptyValue(formValue.picture[0].url) &&
        isEmptyValue(picture)
      ) {
        const mediaPayload = {
          medias: [
            {
              external_reference: null,
              table: 'orders',
              name: formValue.picture[0].uid + '.jpg',
              url_path: formValue.picture[0].url,
              size: 0,
              type: 'orders',
            },
          ],
        }
        mediaId = await HttpRequest.post(`/inspections/image`, mediaPayload)
        properties[
          properties.findIndex((item) => item.field == 'picture')
        ].value = formValue.picture[0].url
      } else if (
        !isEmptyValue(formValue.picture[0].url) &&
        !isEmptyValue(picture)
      ) {
        const mediaPayload = {
          medias: [
            {
              external_reference: null,
              table: 'orders',
              name: picture.name,
              url_path: picture.url_path,
              size: 0,
              type: 'orders',
            },
          ],
        }
        mediaId = await HttpRequest.post(`/inspections/image`, mediaPayload)
        properties[
          properties.findIndex((item) => item.field == 'picture')
        ].value = picture.url_path
      } else {
        properties[
          properties.findIndex((item) => item.field == 'picture')
        ].value = (
          properties[properties.findIndex((item) => item.field == 'picture')]
            .value[0] as any
        ).url
      }
    }

    return {
      mediaId: isEmpty(mediaId) ? mediaId : mediaId.data.data[0].id,
    }
  } catch (error) {
    console.log('error: ', error)
  }
}

export function formatProductDetailFormDataToObject(
  obj: any,
  oldObjectFromSever: any
) {
  var newObject = {}
  var orderObject = {}

  if (
    obj.quantity_breakdown == quantity_breakdown_types_obj.TOTAL_QUANTITY_ONLY
  ) {
    for (const key in obj) {
      const newKey = key.includes('orderQuantity')
      if (newKey) {
        orderObject = !isEmptyValue(obj[key])
          ? isObject(obj[key])
            ? ''
            : String(obj[key])
          : ''
      } else {
        newObject[key] = obj[key]
      }
    }
  } else if (
    obj.quantity_breakdown == quantity_breakdown_types_obj.BY_DESTINATION
  ) {
    for (const key in obj) {
      const newKey = key.includes('~destination~')
      const nameKey = key.replace('~destination~', '')
      if (newKey) {
        orderObject = {
          ...orderObject,
          [nameKey]: { quantity: obj[key] },
          // [nameKey]: obj[key],
        }
      } else {
        newObject[key] = obj[key]
      }
    }
  } else {
    forEach(obj, (value, key) => {
      if (!includes(key, COLOR_SIZE_SEPARATOR_KEY)) {
        newObject[key] = value
        return
      }

      const [size, color] = split(key, COLOR_SIZE_SEPARATOR_KEY)
      set(orderObject, [size, color], value)
    })
  }

  // get combind old and new data
  const attributes = []
  oldObjectFromSever.attributes.forEach((element) => {
    attributes.push({
      ...element,
      value: newObject[element.field],
    })
  })
  const information = []
  oldObjectFromSever.information.forEach((element) => {
    information.push({
      ...element,
      value: !isEmptyValue(newObject[element.field])
        ? newObject[element.field]
        : '',
    })
  })
  const quantity_breakdown = {
    ...oldObjectFromSever.quantity_breakdown,
    value: obj?.quantity_breakdown,
    field: oldObjectFromSever.quantity_breakdown.field,
  }

  const isObjectTypeTotalQuantity = () => {
    return obj?.quantity_breakdown ==
      quantity_breakdown_types_obj.TOTAL_QUANTITY_ONLY
      ? isEmptyValue(orderObject)
        ? ''
        : orderObject
      : orderObject
  }

  const order_quantity = {
    ...oldObjectFromSever.order_quantity,
    value: isObjectTypeTotalQuantity(),
    field: oldObjectFromSever.order_quantity.field,
  }

  return {
    order_quantity,
    attributes,
    information,
    quantity_breakdown,
  }
}

export function formatRequirementFormDataToObject(
  obj: any,
  previousData: any,
  extraDataPayload?: any
) {
  const aqlDataSource = get(extraDataPayload, 'aqlDataSource') || {}
  const propertyValues = get(aqlDataSource, 'property_values') || []

  const otherObject = { measurementSpec: [], productWeightSpec: [] }
  const tempMeasurement = []
  const tempWeight = []

  for (const key in obj) {
    const value = obj[key]
    const newKey = key.split(':')
    if (newKey[0] === 'measurement') {
      tempMeasurement[newKey[2]] = {
        ...tempMeasurement[newKey[2]],
        [newKey[1]]: String(value)?.trim(),
      }
      // console.log
    }
    if (newKey[0] === 'weight') {
      tempWeight[newKey[2]] = {
        ...tempWeight[newKey[2]],
        [newKey[1]]: value,
      }
    }
    if (!newKey[1]) {
      otherObject[key] = value
    }
  }

  tempMeasurement.forEach((element) => {
    otherObject.measurementSpec.push(element)
  })
  tempWeight.forEach((element) => {
    otherObject.productWeightSpec.push(element)
  })

  const information = []
  const measurement = []
  const product_weight = []

  previousData.information.forEach((element) => {
    if (element.field === 'aql') {
      // otherObject[element.field] // currently jsonstring
      const findAqlSelected =
        find(
          propertyValues,
          (item) => item.id === otherObject[element.field]
        ) ?? {}
      information.push({
        ...element,
        parent_id: findAqlSelected?.id || null,
        value: findAqlSelected?.value || '',
      })
    } else {
      information.push({
        ...element,
        value: !isEmptyValue(otherObject[element.field])
          ? otherObject[element.field]
          : '',
      })
    }
  })

  previousData.measurement.forEach((element) => {
    if (element.field === 'measurement_aql') {
      const findMeasurementAqlSelected =
        find(
          propertyValues,
          (item) => item.id === otherObject[element.field]
        ) ?? {}
      measurement.push({
        ...element,
        parent_id: findMeasurementAqlSelected?.id || null,
        value: findMeasurementAqlSelected?.value || '',
      })
    } else {
      measurement.push({
        ...element,
        value:
          element?.data_type === 'json'
            ? orderBy(
                otherObject[element.field],
                (o) => {
                  return new Number(o.index)
                },
                ['asc']
              )
            : otherObject[element.field],
      })
    }
  })

  if (
    !previousData.measurement.some(
      (el: any) => el.field === 'measurement_aql'
    ) &&
    !isEmptyValue(otherObject['measurement_aql'])
  ) {
    const findMeasurementAqlSelected =
      find(
        propertyValues,
        (item) => item.id === otherObject['measurement_aql']
      ) ?? {}
    measurement.push({
      field: 'measurement_aql',
      name: 'Measurement AQL',
      data_type: 'select',
      value: findMeasurementAqlSelected?.value || '',
      parent_id: findMeasurementAqlSelected?.id || null,
      required: false,
    })
  }

  previousData.product_weight.forEach((element) => {
    product_weight.push({
      ...element,
      value: otherObject[element.field],
      field: element.field,
    })
  })

  return { product_weight, measurement, information }
}

export function getOrderQuantityInformDataByColorSize(orderQuantity: any) {
  const temp = new Map()
  for (const sizeKey in orderQuantity) {
    for (const colorKey in orderQuantity[sizeKey]) {
      temp.set(sizeKey + colorKey, orderQuantity[sizeKey][colorKey])
    }
  }
  return temp
}

export function getOrderQuantityInformDataByDestination(orderQuantity: any) {
  const temp = new Map()
  for (const sizeKey in orderQuantity) {
    temp.set(sizeKey, orderQuantity[sizeKey].quantity)
  }
  return temp
}

export function getRandomKey() {
  return `${Math.floor(Math.random() * 10000000)}`
}

export function tranformRequirementDataToFormData(data: any[]) {
  const temp = []
  data.forEach((element) => {
    temp.push({ ...element, field: getRandomKey() })
  })
  return temp
}

export const toFormObjectValues = (formValues = {}, objectValues = []) => {
  const values = []
  objectValues.forEach((found, index) => {
    if (!found) return
    if (found.field === 'picture') return
    if (found.field === 'orderNumber') return
    // if (found.field === 'orderStatus') return
    if (found.field === 'deliveryDate') return

    const key = found.field
    let raw = formValues[key]

    if (raw === undefined || raw === null) {
      // Normalise cleared values
      if (found.data_type === 'file' || found.data_type === 'image') {
        raw = []
      } else {
        raw = ''
      }
    } else if (includes(['date', FIELD_INPUT_TYPE.DATETIME], found.data_type)) {
      // Format date fields to YYYY-MM-DD
      raw = dateFormat(raw, DATE_FORMAT.YYYYMMDD)
    }
    values.push({
      ...found,
      value: raw,
      display_order: found.display_order || index,
    })
  })

  return values
}

export function disableFields(fields, fieldName, currentCollab) {
  if (isEmptyValue(currentCollab)) {
    return false
  }
  if (currentCollab.roles.role == 'owner') {
    return false
  } else if (currentCollab.roles.role == 'editor') {
    if (fields?.some((item) => item.field == fieldName)) {
      return true
    } else {
      return false
    }
  } else {
    return true
  }
}

export function IsExternalUser(order, user) {
  return order?.company?.id !== user?.company?.id
}

export function AllowEditOrder(assignments, user) {
  if (IsAdminRole(user)) {
    return true
  }
  const currentCollab = assignments?.find((item) => item?.user?.id == user?.id)
  if (!isEmptyValue(currentCollab)) {
    if (
      currentCollab?.roles?.role == 'owner' ||
      currentCollab?.roles?.role == 'editor'
    ) {
      return true
    }
  }
  return false
}

export function isInspectionInspector(user: any, record: any) {
  return record?.inspector?.id === user?.id
}

export function isInspectionCreator(user: any, record: any) {
  return record?.created_by?.id === user?.id
}

export function IsCreator(record, user) {
  return record?.created_by.id === user?.id
}

export function getFieldName(fields, field) {
  return fields?.find((item) => item.field == field)?.display_name
}

export function currentUserAssignment(assignments, currentUser) {
  return assignments?.find((item) => item?.user?.id == currentUser?.id)
}
